import { gql } from "graphql-request";

export const GET_UPLOAD_SIGNED_URL = gql`
  query GenerateUploadSignedUrl($fileName: String!, $contentType: String!) {
    generateUploadSignedUrl(fileName: $fileName, contentType: $contentType) {
      signedUrl
      key
    }
  }
`;
export const GET_UPLOAD_SIGNED_URL_FOR_TRADE_DATA = gql`
  query GenerateSignedUrlForTradeData(
    $fileName: String!
    $contentType: String!
    $index: String!
    $clientId: String
    $tenantId: String
    $timeStamp: String
  ) {
    generateSignedUrlForTradeData(
      fileName: $fileName
      contentType: $contentType
      index: $index
      clientId: $clientId
      tenantId: $tenantId
      timeStamp: $timeStamp
    ) {
      signedUrl
      key
    }
  }
`;

export const GET_DOWNLOAD_SIGNED_URL = gql`
  query GenerateAccessSignedUrl($fileName: String!) {
    generateAccessSignedUrl(fileName: $fileName) {
      signedUrl
      key
    }
  }
`;
